export default "__VITE_ASSET__LQH5CAAg__"